import React, { Fragment } from "react";
import { useFormikContext } from "formik";
import PriceTableRow from "../PriceTableRow";
import { getTemplatePrice } from "utils/constants/price";
import Button from "components/Form/fields/Button";
import { BUTTON_CLASS_CONTEXT } from "utils/constants/ui";
import { v4 as uuidv4 } from "uuid";
import classnames from "classnames";
import Analytics, { ADD_PRICE } from "utils/analytics";

const ProductPricesTable = ({
  isLast,
  isFirst,
  name,
  insideTabs,
  id,
  prices,
  productIndex,
  tracking
}) => {
  const { values, setFieldValue } = useFormikContext();
  const priceTableRows =
    prices &&
    prices
      .filter((price) => price.recurring)
      .map((price, priceIx) => {
        const isLast = priceIx === prices.length - 1;
        return (
          <PriceTableRow
            key={priceIx}
            price={price}
            tracking={tracking}
            productIndex={productIndex}
            isLast={isLast}
          />
        );
      });

  const addProductPrice = () => {
    Analytics.track(ADD_PRICE, tracking);
    const updatedProducts = [...values.products];
    const newPrice = getTemplatePrice(id);

    /**
     * Give it a temp uuid so the right index can be found within forms
     */
    newPrice.uuid = uuidv4();
    if (!updatedProducts[productIndex].prices) {
      updatedProducts[productIndex].prices = [];
    }
    updatedProducts[productIndex].prices.push(newPrice);
    setFieldValue("products", updatedProducts);
  };

  const addPriceButton = (
    <Button
      type="button"
      copy="Add price"
      theme="slim"
      onClick={addProductPrice}
      classes={{
        button:
          "fw6 br2 ph3 pv2 border-box input-reset bg-transparent pointer f6 dib flex-shrink-0",
        contextClass: BUTTON_CLASS_CONTEXT.SECONDARY
      }}
    />
  );

  return (
    <li className="w-100">
      {priceTableRows && priceTableRows.length ? (
        <Fragment>
          <table className="w-100" cellSpacing="0">
            <thead>
              <tr className="ph3 br2 bt bl br">
                <th className="fw5 bg-content--secondary f7 f6-ns ph2 pv2 br--top-left hairline-1 bl bt bb br2 br--left br--top">
                  Currency
                </th>
                <th className="fw5 bg-content--secondary f7 f6-ns pl2 tl pv2 hairline-1 bt bb">
                  Amount
                </th>
                <th className="fw5 bg-content--secondary f7 f6-ns ph2 pv2 hairline-1 bt br bb br2 br--right br--top">
                  Billing
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody className="lh-copy">{priceTableRows}</tbody>
          </table>
          <div className="pt3">{addPriceButton}</div>
        </Fragment>
      ) : (
        <div
          className={classnames(
            "w-100 items-center justify-between flex flex-row",
            {
              "br2 ba hairline-1 pa2": !insideTabs
            }
          )}
        >
          <div className="f5">{`No prices yet.`}</div>
          {addPriceButton}
        </div>
      )}
    </li>
  );
};

export default ProductPricesTable;
